<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import CommonRules from "@/mixins/CommonRules";

export default {
    name: "Comments",
    components: {
        AjaxLoad,
    },
    mixins: [
        CommonRules,
    ],
    props: {
        url: {
            type: String,
            required: true,
        },
        reloadInterval: {
            type: Number,
            default: 30,
        },
    },
    data() {
        return {
            ajaxCommentsIntervalId: null,
            isValid: false,
            isSubmit: false,
            form: {
                text: '',
            },
            response: null,
        };
    },
    mounted() {
        if (this.reloadInterval) {
            this.ajaxCommentsIntervalId = setInterval(this.$refs.ajaxComments.load, this.reloadInterval * 1000);
        }
    },
    beforeDestroy() {
        if (this.ajaxCommentsIntervalId) {
            clearInterval(this.ajaxCommentsIntervalId);
        }
    },
    computed: {
        isCanSubmit() {
            return this.isValid && !this.isSubmit && this.isCanCreate;
        },
        data() {
            return this.response?.data || [];
        },
        permissions() {
            return this.response?.meta?.permissions || {};
        },
        isCanCreate() {
            return !!this.permissions.canCreate;
        },
    },
    methods: {
        onSubmitCommentsForm() {
            this.isSubmit = true;
            this.$api.post(this.url, this.form)
                .then(() => {
                    return this.load();
                })
                .then(() => {
                    this.$refs.formComments.reset();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        getUserName(user) {
            return (user.first_name || user.last_name) ? [user.first_name, user.last_name].join(" ") : user.email;
        },
        onKeyDownCtrlEnter() {
            if (this.isCanSubmit) {
                this.onSubmitCommentsForm();
            }
        },
        load() {
            return this.$refs.ajaxComments.load();
        },
        onIntersect (/*entries, observer*/) {
            /**
             */
        },
    },
}
</script>

<template>
    <ajax-load
        v-model="response"
        ref="ajaxComments"
        :url="url"
        :transform="response => response?.data"
    >
        <v-form
            ref="formComments"
            v-model="isValid"
            @submit.prevent="onSubmitCommentsForm"
        >

            <v-timeline
                align-top
                dense
                clipped
            >
                <v-slide-x-transition
                    group
                >
                    <v-timeline-item
                        v-for="item in data"
                        :key="item.id"
                        class="mb-4 mr-4"
                        small
                    >

                        <v-row justify="space-between" v-intersect="onIntersect">
                            <v-col>
                                <div class="comment-content" :class="item.style">{{ item.text }}</div>
                                <div class="mt-2 grey--text text-body-2">
                                    <template v-if="item.created_by">
                                        {{ getUserName(item.created_by) }},
                                    </template>
                                    {{ item.created_at | moment('DD.MM.Y HH:mm') }}
                                </div>
                            </v-col>
                        </v-row>

                    </v-timeline-item>

                    <v-timeline-item
                        v-if="isCanCreate"
                        key="new"
                        small
                        class="mr-4"
                    >
                        <v-textarea
                            v-model="form.text"
                            :disabled="isSubmit"
                            :loading="isSubmit"
                            :rules="[rules.requiredTrim]"
                            :rows="1"
                            @keydown.ctrl.enter="onKeyDownCtrlEnter"
                            label="Комментарий"
                            auto-grow
                            hide-details
                            class="pt-0 mt-0"
                        ></v-textarea>
                        <v-btn
                            :disabled="!isCanSubmit"
                            class="mt-4"
                            color="primary"
                            type="submit"
                        >
                            Добавить
                        </v-btn>
                    </v-timeline-item>

                </v-slide-x-transition>
            </v-timeline>

        </v-form>
    </ajax-load>
</template>

<style scoped lang="css">
>>> .comment-content {
    word-break: break-word;
    white-space: break-spaces;
}
>>> .comment-content.approved {
    color: darkgreen;
    font-weight: 500;
}
>>> .comment-content.declined {
    color: #a50e2d;
    font-weight: 500;
}
</style>
